import { FC, useContext } from 'react';
// 组件
import { ProButton } from '../../../../antd';
import SuperForm from '../../../../SuperForm';
// 方法
import StrategyPageCountext from '../../../context/strategyCountext';
import { getOptionalValues } from '../../util';
// 常量
import { StrategyPageContentProps } from '../../../interface';

const Content: FC<StrategyPageContentProps> = props => {
  const { contentFormRef, disabled } = props;
  const { contentFormItems, optionalFormRef, optionalFormItems, pageType, dispatch, } = useContext(StrategyPageCountext);
  /** 清空 */
  const handleEmpty = () => {
    optionalFormRef?.current?.resetFields();
    optionalFormRef?.current?.setFieldsValue(getOptionalValues(optionalFormItems, {}));
    dispatch('empty', {});
  };
  return (
    <div className="yb-StrategyPage-content yb-StrategyPage-item">
      <div className='yb-StrategyPage-content-header'>
        <div className='yb-StrategyPage-content-header-label'>已选条件</div>
        {
          pageType !== 'detail' && (
            <ProButton onClick={handleEmpty}>清空</ProButton>
          )
        }
      </div>
      <SuperForm
        actionRef={contentFormRef}
        testId='strategy-page-content-1'
        className='yb-StrategyPage-content-form'
        formItems={contentFormItems}
        defaultLineNumber={1}
        defaultLabelCol={{span: 8}}
        disabled={disabled}
      />
    </div>
  );
};

export default Content;
